module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6530c28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/ListMain/CardBox/CarItemForList.vue
// module id = 887
// module chunks = 5